import {useIsLargeDevice} from '@jobseeker/lotus/hooks';
import {Box, SxProps, Theme, Typography} from '@mui/material';
import {useEffect, useState} from 'react';

const ExpandableText = ({
  text,
  compressLabel,
  expandLabel,
  bgColor = false,
  fontSizePhone = 14,
  fontSizeDesktop = 14,
  fontColor = '#7E7E7E',
  fontWeightPhone = 400,
  sx = {},
}: {
  text: string;
  compressLabel: string;
  expandLabel: string;
  bgColor?: boolean;
  fontSizePhone?: number;
  fontSizeDesktop?: number;
  fontColor?: string;
  fontWeightPhone?: number;
  sx?: SxProps<Theme> | undefined;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [shouldExpand, setShouldExpand] = useState(false);
  const isAboveLarge = useIsLargeDevice(900);
  useEffect(() => {
    setShouldExpand(text.length >= 100);
  }, [text]);
  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };
  return (
    <Box
      p={!isAboveLarge && bgColor ? 1 : 0}
      display={'flex'}
      justifyContent={'flex-start'}
      alignItems={'flex-start'}
      sx={{
        borderRadius: 3,
        background:
          !isAboveLarge && bgColor
            ? 'linear-gradient(0deg, rgba(255, 255, 255, 0.70) 0%, rgba(255, 255, 255, 0.70) 100%), #E1E4E9'
            : 'none',
      }}
    >
      <Typography
        variant="body2"
        maxWidth={isAboveLarge ? 270 : '100%'}
        sx={{
          color: fontColor,
          fontSize: isAboveLarge ? fontSizeDesktop : fontSizePhone,
          lineHeight: isAboveLarge ? '18px' : '14px',
          fontWeight: isAboveLarge ? 500 : fontWeightPhone,
          ...sx,
        }}
      >
        {!isAboveLarge && bgColor && (
          <Typography
            fontSize={fontSizePhone}
            lineHeight={'14px'}
            fontWeight={500}
            component="span"
          >
            Message:&nbsp;
          </Typography>
        )}
        {shouldExpand ? (
          <>
            {isExpanded ? (
              <>
                {text}
                <Typography
                  component="span"
                  color="primary"
                  onClick={toggleExpansion}
                  sx={{
                    cursor: 'pointer',
                    ml: 1,
                    fontSize: isAboveLarge ? fontSizeDesktop : fontSizePhone,
                    lineHeight: isAboveLarge ? '18px' : '14px',
                    fontWeight: isAboveLarge ? 500 : fontWeightPhone,
                  }}
                >
                  {compressLabel}
                </Typography>
              </>
            ) : (
              <>
                {`${text.slice(0, 100)}...`}
                <Typography
                  component="span"
                  color="primary"
                  onClick={toggleExpansion}
                  sx={{
                    cursor: 'pointer',
                    ml: 1,
                    fontSize: isAboveLarge ? fontSizeDesktop : fontSizePhone,
                    lineHeight: isAboveLarge ? '18px' : '14px',
                    fontWeight: isAboveLarge ? 500 : fontWeightPhone,
                  }}
                >
                  {expandLabel}
                </Typography>
              </>
            )}
          </>
        ) : (
          text
        )}
      </Typography>
    </Box>
  );
};

export default ExpandableText;
